import { Heading, Paragraph } from '@purpur/library';
import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurShadow,
    getPurpurSpacing,
    getPurpurTypography,
} from '@telialt/common-theme/src/purpurSelectors';

type WrapperProps = {
    $hasBadges?: boolean;
};

export const ProductCardSmallWrapper = styled.a<WrapperProps>`
    position: relative;
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderWeak')};
    border-radius: ${getPurpurBorder('radiusMd')};
    background: ${getPurpurColor('functionalWhite')};
    padding-top: ${({ $hasBadges }) => ($hasBadges ? getPurpurSpacing('300') : getPurpurSpacing('200'))};
    padding-bottom: ${({ $hasBadges }) => ($hasBadges ? getPurpurSpacing('300') : getPurpurSpacing('200'))};
    padding-left: ${getPurpurSpacing('200')};
    padding-right: ${getPurpurSpacing('200')};
    display: flex;
    align-items: center;
    gap: ${getPurpurSpacing('200')};
    box-shadow: ${getPurpurShadow('md')};
    &,
    &:hover,
    &:focus {
        color: ${getPurpurColor('textDefault')};
        text-decoration: none;
    }

    ${purpurFocus()};
`;

export const ProductCardSmallBadges = styled.div`
    position: absolute;
    top: 0;
    right: ${getPurpurSpacing('200')};
    line-height: ${getPurpurTypography('lineHeightTight')};
    display: flex;
    gap: ${getPurpurSpacing('100')};
`;

export const ProductCardSmallImageContainer = styled.div`
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4rem;
    height: 4rem;
`;

export const ProductCardSmallImage = styled.img`
    max-width: 100%;
    max-height: 100%;
`;

export const ProductCardSmallContent = styled.div`
    & > * {
        margin-bottom: ${getPurpurSpacing('50')};
        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const ProductCardSmallProductName = styled(Heading).attrs({ variant: 'subsection-100' })`
    font-weight: ${getPurpurTypography('weightBold')};
    word-break: break-word;
`;

export const ProductCardSmallMonthlyPriceLabel = styled.span`
    font-size: ${getPurpurTypography('scale75')};
    font-weight: ${getPurpurTypography('weightNormal')};
    color: ${getPurpurColor('textMedium')};
`;

export const ProductCardSmallMonthlyPrice = styled.span`
    color: ${getPurpurColor('brandOffBlack')};
`;

export const ProductCardSmallMonthlyPriceUnit = styled.span`
    font-size: ${getPurpurTypography('scale75')};
    font-weight: ${getPurpurTypography('weightMedium')};
    color: ${getPurpurColor('brandOffBlack')};
`;

export const ProductCardSmallCommitment = styled(Paragraph).attrs({ variant: 'additional-100' })`
    color: ${getPurpurColor('textMedium')};
`;

export const ProductCardSmallFullPrices = styled(Paragraph).attrs({ variant: 'paragraph-100' })`
    line-height: ${getPurpurTypography('lineHeightDefault')};
`;

export const ProductCardSmallFullPrice = styled.span`
    font-weight: ${getPurpurTypography('weightBold')};
`;

export const ProductCardSmallFullPriceOld = styled.span`
    text-decoration: line-through;
`;

export const ResidualValue = styled(Paragraph).attrs({ variant: 'additional-100' })`
    color: ${getPurpurColor('textMedium')};
`;
